import ads from '@/services/api/ads'
import * as types from './mutation-types.js'

const actions = {
  async createAd ({ state }, payload) {
    return ads.createAd(state.createAction, payload)
  },
  async deleteAd (context, path) {
    return ads.deleteAd(path)
  },
  async getAds ({ commit }) {
    const result = await ads.getAds('/ads')

    commit(types.SET_CAN_CREATE_AD, result)
    commit(types.SET_AD_LIST, result.collection)
  },
  async updateAd (context, { path, payload }) {
    return ads.updateAd(path, payload)
  }
}

export default actions
